import { Palette } from '@ppwr/poker'
import * as React from 'react'
import Svg, { Rect, Path } from 'react-native-svg'
import { useResponsive } from '@/screens/new-design/hooks'

interface PauseSVGProps {
  bgFill?: string
  iconFill?: string
}

export const PauseSVG = ({
  bgFill = Palette['Shades/Maroon 2'],
  iconFill = Palette['Brand/Cream'],
  ...rest
}: React.ComponentProps<typeof Svg> & PauseSVGProps) => {
  const { verticalScale } = useResponsive()

  return (
    <Svg width={verticalScale(40)} height={verticalScale(40)} viewBox="0 0 40 40" fill="none" {...rest}>
      <Rect width={40} height={40} rx={20} fill={bgFill} />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8333 13.9583C16.4086 13.9583 16.875 14.4247 16.875 15V25C16.875 25.5753 16.4086 26.0416 15.8333 26.0416C15.258 26.0416 14.7917 25.5753 14.7917 25V15C14.7917 14.4247 15.258 13.9583 15.8333 13.9583Z"
        fill={iconFill}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.1667 13.9583C24.742 13.9583 25.2083 14.4247 25.2083 15V25C25.2083 25.5753 24.742 26.0416 24.1667 26.0416C23.5914 26.0416 23.125 25.5753 23.125 25V15C23.125 14.4247 23.5914 13.9583 24.1667 13.9583Z"
        fill={iconFill}
      />
    </Svg>
  )
}
